import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const PageWrapper = styled.div`
  max-width: 640px;
  margin: 60px auto;
  padding: 0 16px;
`;

export const Card = styled.div`
  background: #fff;
  border-radius: 8px;
  border: 1px solid #dadce0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  padding: 32px;
  margin-bottom: 24px;
`;

export const PageTitle = styled.h1`
  font-size: 28px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 8px;
  text-align: center;
`;

export const PageSubtitle = styled.p`
  font-size: 16px;
  color: #5f6368;
  text-align: center;
  margin-bottom: 24px;
`;

export const EventName = styled.h2`
  font-size: 22px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 4px;
`;

export const EventDetail = styled.p`
  font-size: 14px;
  color: #5f6368;
  margin-bottom: 4px;
`;

export const SectionTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 16px;
`;

export const StudentCard = styled.div`
  border: ${(props) =>
    props.selected ? '2px solid #1a73e8' : '1px solid #dadce0'};
  background: ${(props) => (props.selected ? '#e8f0fe' : '#fff')};
  padding: ${(props) => (props.selected ? '15px' : '16px')};
  border-radius: 8px;
  margin-bottom: 8px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    border-color: #1a73e8;
    background: ${(props) => (props.selected ? '#e8f0fe' : '#f8f9fa')};
  }
`;

export const StudentName = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: #1a1a1a;
`;

export const StudentMeta = styled.div`
  font-size: 13px;
  color: #5f6368;
  margin-top: 2px;
`;

export const RegisteredBadge = styled.span`
  display: inline-block;
  background: #0f9d58;
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  padding: 2px 8px;
  border-radius: 12px;
  margin-left: 8px;
`;

export const PrimaryButton = styled.button`
  background-color: #1a73e8;
  color: white;
  font-weight: 600;
  font-size: 16px;
  padding: 12px 24px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  width: 100%;
  transition: background-color 0.2s;

  &:hover {
    background-color: #155ec2;
  }

  &:disabled {
    background-color: #94bff8;
    cursor: not-allowed;
  }
`;

export const SecondaryButton = styled.button`
  background-color: #fff;
  color: #1a73e8;
  font-weight: 500;
  font-size: 14px;
  padding: 10px 20px;
  border-radius: 6px;
  border: 1px solid #dadce0;
  cursor: pointer;
  width: 100%;
  transition: all 0.2s;

  &:hover {
    background-color: #f8f9fa;
    border-color: #1a73e8;
  }
`;

export const TextInput = styled.input`
  width: 100%;
  padding: 12px;
  border: 2px solid #dadce0;
  border-radius: 6px;
  font-size: 16px;
  box-sizing: border-box;
  margin-bottom: 12px;

  &:focus {
    border-color: #1a73e8;
    outline: none;
  }
`;

export const SuccessMessage = styled.div`
  background-color: #e6f4ea;
  border: 1px solid #0f9d58;
  color: #137333;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 16px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;

export const ErrorMessage = styled.div`
  background-color: #fce8e6;
  border: 1px solid #d93025;
  color: #c5221f;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 16px;
`;

export const LoginPrompt = styled.div`
  text-align: center;
  padding: 24px 0;
`;

export const Divider = styled.hr`
  border: none;
  border-top: 1px solid #dadce0;
  margin: 20px 0;
`;

export const FormRow = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
`;

export const FormLabel = styled.label`
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #5f6368;
  margin-bottom: 6px;
`;

export const Checkbox = styled.div`
  width: 20px;
  height: 20px;
  border: 2px solid ${(props) => (props.checked ? '#1a73e8' : '#dadce0')};
  border-radius: 4px;
  background: ${(props) => (props.checked ? '#1a73e8' : '#fff')};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  &::after {
    content: '${(props) => (props.checked ? '\\2713' : '')}';
    color: #fff;
    font-size: 14px;
    font-weight: bold;
  }
`;

export const StudentCardRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const ConfirmationOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const ConfirmationDialog = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 32px;
  max-width: 480px;
  width: 90%;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.15);
`;

export const ConfirmationTitle = styled.h3`
  font-size: 20px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 12px;
`;

export const ConfirmationText = styled.p`
  font-size: 15px;
  color: #5f6368;
  margin-bottom: 24px;
  line-height: 1.5;
`;

export const ConfirmationActions = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
`;

export const EventPickerCard = styled.div`
  border: ${(props) =>
    props.selected ? '2px solid #1a73e8' : '1px solid #dadce0'};
  background: ${(props) =>
    props.closed ? '#f8f8f8' : props.selected ? '#e8f0fe' : '#fff'};
  padding: ${(props) => (props.selected ? '15px' : '16px')};
  border-radius: 8px;
  margin-bottom: 8px;
  cursor: pointer;
  transition: all 0.2s;
  opacity: ${(props) => (props.closed ? 0.7 : 1)};

  &:hover {
    border-color: ${(props) => (props.closed ? '#dadce0' : '#1a73e8')};
    background: ${(props) =>
      props.closed ? '#f0f0f0' : props.selected ? '#e8f0fe' : '#f8f9fa'};
  }
`;

export const EventPickerName = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: #1a1a1a;
`;

export const EventPickerMeta = styled.div`
  font-size: 13px;
  color: #5f6368;
  margin-top: 2px;
`;

export const ClosedMessage = styled.div`
  text-align: center;
  padding: 24px;
  border: 1px solid #f5c6cb;
  background: #fdf2f2;
  border-radius: 8px;
  color: #5f6368;

  h3 {
    font-size: 20px;
    font-weight: 600;
    color: #c5221f;
    margin-bottom: 12px;
  }

  p {
    font-size: 15px;
    line-height: 1.5;
    margin-bottom: 8px;
  }
`;

export const HelpSection = styled.div`
  margin-top: 24px;
  border-top: 1px solid #e0e0e0;
  padding-top: 20px;
  color: #5f6368;
  font-size: 14px;
`;

export const HelpTitle = styled.p`
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #5f6368;
  margin-bottom: 10px;
`;

export const HelpLink = styled.a`
  color: #1a73e8;
  text-decoration: none;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 15px;

  &:hover {
    text-decoration: underline;
  }
`;

export const LoadingSpinner = styled.div`
  text-align: center;
  padding: 40px;
  color: #5f6368;
  font-size: 16px;
`;

export const BackLink = styled(Link)`
  display: inline-block;
  color: #1a73e8;
  font-size: 14px;
  margin-bottom: 16px;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

// Shared list components used by AllRegistrations and MyRegistrations
export const ListRegistrationItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 10px 0;
  border-bottom: 1px solid #eee;

  &:last-child {
    border-bottom: none;
  }
`;

export const ListEventInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const ListStudentName = styled.div`
  font-weight: 600;
  color: ${(props) => (props.muted ? '#9aa0a6' : '#1a1a1a')};
  font-size: 15px;
`;

export const ListEventMeta = styled.div`
  font-size: 13px;
  color: ${(props) => (props.muted ? '#bdc1c6' : '#5f6368')};
  margin-top: 1px;
`;

export const ListRemoveLink = styled.span`
  color: #5f6368;
  cursor: pointer;
  text-decoration: underline;
  font-size: 13px;
  white-space: nowrap;
  padding-top: 2px;
`;

export const ListEmptyState = styled.p`
  color: #5f6368;
  font-size: 14px;
  margin: 0;
`;
